
import { Options, Vue } from "vue-class-component";
import { useStore } from "../../store";
import TranslateService from "../../services/translate.service";
import RouterService from "../../services/router.service";
import { computed, ref } from "vue";
import layoutService from "../../services/layout.service";
import {baseUrl} from "../../config/firebase";
@Options({})
export default class Base extends Vue {
  public store = useStore();
  public currentUser = computed(() => this.store.getters.getCurrentUser).value;
  public currentlanguge = TranslateService.language;
  public dialogRef = ref({});
  public baseUrl = baseUrl;
  created() {
    TranslateService.currentLocale.subscribe(lang => {
      this.currentlanguge = lang;
    });
    layoutService.getDialog.subscribe(dialog => {
      this.dialogRef.value = dialog;
    });
  }

  public t(key: string) {
    return TranslateService.translate(key, this.currentlanguge);
  }

  public redirectTo(name: string, paramName?: string, param?: any) {
    RouterService.redirectTo(name, paramName, param);
  }

  defaultAvatar =
    "https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png";
}
